var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.height+'px'})},[_c('div',{staticClass:"status-bar",style:({height: _vm.height+'px', backgroundColor: _vm.backgroundColor})})])}
var staticRenderFns = []

export { render, staticRenderFns }